import React from 'react';
import { Building2, CreditCard, Headphones, Globe, FileText, Share2, Wrench, MapPin, Rocket, User, PenTool } from 'lucide-react';

export type NavActionType = 'prompt' | 'route' | 'callback' | 'category';

export interface NavNode {
  id: string;
  title: string;
  icon?: React.ReactNode;
  type: NavActionType;
  action?: string;
  children?: NavNode[];
}

export const navigationConfig: NavNode[] = [
  {
    id: 'platform',
    title: 'Platform',
    icon: <Building2 className="w-5 h-5 text-blue-500" />,
    type: 'category',
    children: [
      {
        id: 'onboarding',
        title: 'Onboarding',
        icon: <Rocket className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'onb-overview',           title: 'Overview & Progress',              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'onb-business-info',      title: 'Step 1 — Business Info',           type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'onb-ecosystem',          title: 'Step 2 — Ecosystem',               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'onb-business-portfolio', title: 'Step 3 — Business Portfolio',      type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'onb-terms',              title: 'Step 4 — Terms & Conditions',      type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'onb-post-onboarding',    title: 'Post-Onboarding & Dashboard',      type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'onb-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'onb-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'profile',
        title: 'Profile',
        icon: <User className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'prof-contact-identity',     title: 'Contact & Identity',              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'prof-business-details',     title: 'Business Details',                type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'prof-subscription-billing', title: 'Subscription & Billing',          type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'prof-help-centre',          title: 'Help Centre',                     type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'prof-data-behaviour',       title: 'Data Behaviour & Technical Rules', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'prof-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'prof-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'website-builder',
        title: 'Website Builder',
        icon: <FileText className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'wb-access-overview',  title: 'Access & Overview',              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-site-structure',   title: 'Sitemap & Page Structure',       type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-page-content',     title: 'Page Content',                   type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-templates-theme',  title: 'Design & Branding',              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-seo-foundation',   title: 'SEO Foundation',                 type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-analytics',        title: 'Analytics Setup (GA4 & GSC)',    type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-output-package',   title: 'Outputs & Downloads',            type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'wb-integrations',     title: 'Platform Integrations & Limits', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'wb-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'wb-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'gmb-manager',
        title: 'GMB Manager',
        icon: <MapPin className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'gmb-overview',        title: 'Overview & Purpose',               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-classification',  title: 'Business Classification & Visibility', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-setup',           title: 'First-Time Setup & Authentication', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-competition',     title: 'Competition Logic',                type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-strategy',        title: 'Strategy (Profile Health, Goals)', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-implementation',  title: 'Implementation (Photos, Posts, Q&A)', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-governance',      title: 'Governance',                       type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-optimization',    title: 'Optimization',                     type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-keywords',        title: 'Keyword Handling',                 type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'gmb-edge-cases',      title: 'Edge Cases',                       type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'gmb-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'gmb-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'social-media-manager',
        title: 'Social Media Manager',
        icon: <Share2 className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'smm-general',         title: 'General',                  type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-setup',           title: 'First-Time Setup',         type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-brand-comms',     title: 'Brand Communication Setup', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-content-plan',    title: 'Content Planning Model',   type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-strategy',        title: 'Strategy',                 type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-implementation',  title: 'Implementation',           type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-governance',      title: 'Governance',               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-optimization',    title: 'Optimization',             type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'smm-plans',           title: 'Plans & Limits',           type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'smm-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'smm-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'seo-manager',
        title: 'SEO Manager',
        icon: <Globe className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'seo-general',         title: 'General',           type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'seo-activation',      title: 'Activation & Access', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'seo-strategy',        title: 'Strategy',          type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'seo-implementation',  title: 'Implementation',    type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'seo-governance',      title: 'Governance',        type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'seo-optimization',    title: 'Optimization',      type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'seo-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'seo-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'utility-manager',
        title: 'Utility Manager (Keyword Planner)',
        icon: <Wrench className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'um-what-is',          title: 'What Is Keyword Planning?',             type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-where-from',       title: 'Where Do Keywords Come From?',          type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-how-built',        title: 'How the Keyword List Is Built',         type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-scoring',          title: 'How Keywords Are Scored & Prioritized', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-groups',           title: 'Keyword Groups',                        type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-competitor',       title: 'Competitor Keywords',                   type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-local-online',     title: 'Local vs Online Keywords',              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'um-new-business',     title: 'New Businesses',                        type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'um-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'um-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      },
      {
        id: 'adhoc-content',
        title: 'Ad-Hoc Content Creator',
        icon: <PenTool className="w-4 h-4 text-gray-500" />,
        type: 'category',
        children: [
          { id: 'adhoc-overview',       title: 'Overview & Core Philosophy',               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-user-types',     title: 'User Types',                               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-brand-intel',    title: 'Brand Intelligence Engine',                type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-content-types',  title: 'Content Discovery & Content Types',        type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-static-post',    title: 'Social Media Static Post',                 type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-infographic',    title: 'Social Media Infographic',                 type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-carousel',       title: 'Social Media Carousel',                    type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-video',          title: 'Social Media Video & Motion',              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-linkedin',       title: 'LinkedIn Article',                         type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-blog',           title: 'Blog Post',                                type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-whitepaper',     title: 'White Paper',                              type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-case-study',     title: 'Case Study',                               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-landing-page',   title: 'Landing Page Content',                     type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-print',          title: 'Print & Offline Formats',                  type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-presentations',  title: 'Presentations & Catalogues',               type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          { id: 'adhoc-common',         title: 'Common Features Across All Content Types', type: 'callback', action: 'PLATFORM_SUB_CATEGORY' },
          {
            id: 'adhoc-other',
            title: 'Other Options / Something Else',
            type: 'category',
            children: [
              { id: 'adhoc-raise-ticket', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'payments',
    title: 'Payments & Pricing',
    icon: <CreditCard className="w-5 h-5 text-purple-500" />,
    type: 'category',
    children: [
      { id: 'pay-pricing', title: 'View Pricing Plans', type: 'callback', action: 'PAY_PRICING' },
      { id: 'pay-billing', title: 'Billing & Invoices', type: 'callback', action: 'PAY_BILLING' },
      { id: 'pay-issues', title: 'Payment Issues', type: 'callback', action: 'PAY_ISSUES' }
    ]
  },
  {
    id: 'support',
    title: 'Contact Support',
    icon: <Headphones className="w-5 h-5 text-green-500" />,
    type: 'category',
    children: [
      { id: 'sup-faq', title: 'Browse FAQ', type: 'callback', action: 'SUP_FAQ' },
      { id: 'sup-raise', title: 'Raise Ticket', type: 'callback', action: 'RAISE_TICKET' },
      { id: 'sup-status', title: 'View Ticket Status', type: 'callback', action: 'SUP_STATUS' }
    ]
  }
];
